import { Schema, type Effect, type Scope } from "effect";
import type { ImmutableModelFailure } from "./model.ts";

export class ImmutableModelAdmissionFailure extends Schema.TaggedError<ImmutableModelAdmissionFailure>()("ImmutableModelAdmissionFailure", {
  reason: Schema.Literals(["key", "contents", "identity", "creating", "closed"]),
  identity: Schema.optional(Schema.String)
}) {
  get message(): string {
    switch (this.reason) {
      case "key": return "Immutable model key is invalid.";
      case "contents": return "Immutable model contents must be text.";
      case "identity": return `Immutable model identity ${this.identity} changed contents.`;
      case "creating": return "Immutable model creation cannot borrow its pending identity.";
      case "closed": return "Immutable model owner is closed.";
    }
  }
}

export type ImmutableRegistryFailure = ImmutableModelFailure | ImmutableModelAdmissionFailure;
export interface ImmutableLease<Model> {
  readonly model: Model;
  readonly release: Effect.Effect<void>;
}
export interface ImmutableAcquire<Model, E = ImmutableModelFailure> {
  readonly key: unknown;
  readonly contents: unknown;
  readonly create: Effect.Effect<Model, E | ImmutableModelAdmissionFailure, Scope.Scope>;
  readonly validate?: (model: Model) => Effect.Effect<void, E | ImmutableModelAdmissionFailure, Scope.Scope>;
}
export interface ImmutableRegistry<Model, E = ImmutableModelFailure> {
  readonly acquire: (request: ImmutableAcquire<Model, E>) => Effect.Effect<ImmutableLease<Model>, E | ImmutableModelAdmissionFailure, Scope.Scope>;
  readonly inspect: Effect.Effect<readonly Readonly<{ key: string; references: number }>[]>;
}
